import React from 'react';
import { Form } from '../../../components/form/Form';
import { useFormSubmit } from '../../../controllers/useSubmitForm';

export const SlugForm = props => {
    const {
        route: { params },
    } = props;
    const { row, website, api = '' } = params;
    let { onSubmit } = useFormSubmit({
        uri: `${api}`,
        eventSourceId: ['domain', 'blog', 'caseStudy'],
    });

    return (
        <Form
            api={`${api}/${row?._id}`}
            fields={{
                slug: 1,
            }}
            defaultValues={{
                website,
            }}
            onSubmit={onSubmit}
            layoutFields={[
                {
                    label: 'Slug',
                    type: 'textArea',
                    field: 'slug',
                    required: true,
                }
            ]}
            {...props}
        />
    );
};

export const AddSlugForm = props => {
    return <SlugForm header="Add Slug" {...props} />;
};

export const UpdateSlugForm = props => {
    return (
        <SlugForm mode="edit" header="Update Slug" {...props} />
    );
};
